module.exports = __webpack_public_path__ + "static/client-logos-89b9f0c52ca96e12c93bc3e6248b6c5b.png";